import { SkeletonText, SkeletonButton } from '@dev-spendesk/grapes';
import React from 'react';

export const SendToPaymentLoader = () => {
  return (
    <div className="m-auto flex h-[269px] flex-col place-content-center place-items-center">
      <SkeletonText size="xl" width="60%" className="mb-24" />
      <SkeletonText size="xxl" width="40%" className="mb-32" />
      <SkeletonText size="l" width="70%" className="mb-32" />
      <SkeletonButton width="100%" />
    </div>
  );
};
